export const CONFIGURATION_MANAGEMENT_MODAL = 'CONFIGURATION_MANAGEMENT_MODAL'
export const PAGE_NUMBER = 1
